import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { AvatarStack } from '@primer/react';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PropsTable = makeShortcode("PropsTable");
const PropsTableRow = makeShortcode("PropsTableRow");
const PropsTableSxRow = makeShortcode("PropsTableSxRow");
const ComponentChecklist = makeShortcode("ComponentChecklist");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {AvatarStack} from '@primer/react'
`}</code></pre>
    <h2>{`Examples`}</h2>
    <h3>{`Default`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<AvatarStack>
  <Avatar alt="Primer" src="https://avatars.githubusercontent.com/primer" />
  <Avatar alt="GitHub" src="https://avatars.githubusercontent.com/github" />
  <Avatar alt="Atom" src="https://avatars.githubusercontent.com/atom" />
  <Avatar alt="Desktop" src="https://avatars.githubusercontent.com/desktop" />
</AvatarStack>
`}</code></pre>
    <h3>{`Right aligned`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<AvatarStack alignRight>
  <Avatar alt="Primer" src="https://avatars.githubusercontent.com/primer" />
  <Avatar alt="GitHub" src="https://avatars.githubusercontent.com/github" />
  <Avatar alt="Atom" src="https://avatars.githubusercontent.com/atom" />
  <Avatar alt="Desktop" src="https://avatars.githubusercontent.com/desktop" />
</AvatarStack>
`}</code></pre>
    <h2>{`Props`}</h2>
    <h3>{`AvatarStack`}</h3>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="alignRight" type="boolean" defaultValue="false" description="Align the avatars to the right" mdxType="PropsTableRow" />
  <PropsTableSxRow mdxType="PropsTableSxRow" />
    </PropsTable>
    <h2>{`Status`}</h2>
    <ComponentChecklist items={{
      propsDocumented: true,
      noUnnecessaryDeps: true,
      adaptsToThemes: true,
      adaptsToScreenSizes: true,
      fullTestCoverage: false,
      usedInProduction: true,
      usageExamplesDocumented: true,
      designReviewed: false,
      a11yReviewed: false,
      stableApi: false,
      addressedApiFeedback: false,
      hasDesignGuidelines: false,
      hasFigmaComponent: false
    }} mdxType="ComponentChecklist" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      